var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.81 15.9L21.21 19.29C21.3993 19.4778 21.5058 19.7334 21.5058 20C21.5058 20.2666 21.3993 20.5222 21.21 20.71C21.0222 20.8993 20.7666 21.0058 20.5 21.0058C20.2334 21.0058 19.9778 20.8993 19.79 20.71L16.4 17.31C15.0025 18.407 13.2767 19.0022 11.5 19C7.08172 19 3.5 15.4183 3.5 11C3.5 6.58172 7.08172 3 11.5 3C15.9183 3 19.5 6.58172 19.5 11C19.5022 12.7767 18.907 14.5025 17.81 15.9ZM11.5 5C8.18629 5 5.5 7.68629 5.5 11C5.5 14.3137 8.18629 17 11.5 17C14.8137 17 17.5 14.3137 17.5 11C17.5 7.68629 14.8137 5 11.5 5Z",
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsIcSearch);
export default __webpack_public_path__ + "static/media/icons_ic_search.aedd2f9d3391257c6f34b1216723575a.svg";
export { ForwardRef as ReactComponent };